const size = {
  mobile: 480,
  tablet: 640,
  desktop: 1200
};


export const device = {
  mobile: `(min-width: ${size.mobile}px)`,
  tablet: `(min-width: ${size.tablet}px)`,
  desktop: `(min-width: ${size.desktop}px)`
}

